<div #wrapper class="wrapper" style="height: 100%;">
    <div class="modal-header-wrapper">
        <div class="text-wrapper" [class.font-weight-600]="true">Модифициране {{ day }} - {{ dailyMeal }}</div>
        <div class="responsive-flex-wrapper shortcuts">
            <i class="ti-close" (click)="onClose()"></i>
        </div>
    </div>

    <ng-container>
        <div class="modal-body">
            <button
                    (click)="openFormModal()"
                    class="button-create btn btn-sm btn-success btn-icon-text">
                <i class="ti-save btn-icon-prepend"></i>
                Създаване на нова конфигурация
            </button>

            <div class="clear"></div>

            <table class="daily-macro-table table table-striped scrollable-table">
                <thead>
                <tr>
                    <th>Хранене</th>
                    <th>Процент</th>
                    <th>Настройки</th>
                </tr>
                </thead>
                <tbody>

                <ng-container *ngIf="mealOverwrites">
                    <tr *ngFor="let mealOverwrite of mealOverwrites">
                        <td>
                            {{ mealOverwrite.meal.dailyMeal.title + ' - ' + mealOverwrite.meal.title }}
                        </td>
                        <td>
                            {{ mealOverwrite.overwrite_percentage }}%
                        </td>
                        <td>
                            <button
                                    (click)="delete(mealOverwrite)"
                                    type="button"
                                    class="btn-delete btn btn-sm btn-danger btn-icon-text">
                                <i class="ti-trash btn-icon-prepend"></i>
                                Изтрий
                            </button>
                        </td>
                    </tr>
                </ng-container>

                </tbody>
            </table>
        </div>
    </ng-container>
</div>
